var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3Veterinarios(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "70px",
    height: "70px",
    viewBox: "0 0 70 70",
    enableBackground: "new 0 0 70 70",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#AF1868",
    cx: 35,
    cy: 35,
    r: 35
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Glyph"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M27.311,35.606v5.187c2.101,0.424,3.688,2.287,3.688,4.518v3.687c0,0.507-0.414,0.921-0.922,0.921h-0.922 c-0.507,0-0.921-0.414-0.921-0.921v-0.922c0-0.507,0.414-0.921,0.921-0.921v-1.844c0-1.521-1.244-2.766-2.766-2.766 c-1.521,0-2.765,1.245-2.765,2.766v1.844c0.507,0,0.921,0.414,0.921,0.921v0.922c0,0.507-0.414,0.921-0.921,0.921h-0.922 c-0.507,0-0.921-0.414-0.921-0.921v-3.687c0-2.23,1.584-4.094,3.686-4.518v-6.395c-5.409,2.184-9.217,7.484-9.217,13.677v6.452 h36.869v-6.452c0-6.193-3.808-11.493-9.217-13.677v-0.001v7.393c1.078,0.368,1.843,1.393,1.843,2.601 c0,1.527-1.235,2.765-2.765,2.765c-1.53,0-2.766-1.237-2.766-2.765c0-1.208,0.766-2.232,1.844-2.601v-6.183"
  }))), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 34.685,
    cy: 21.789,
    r: 12.608
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Veterinarios);
export default __webpack_public_path__ + "static/media/3-veterinarios.bc305f0634d728cefa12467816f9b325.svg";
export { ForwardRef as ReactComponent };